<template>
    <ModalComponent
        :class="studySearchModal ? '' : 'vuw-hidden'"
        v-on:close="studySearchModal = !studySearchModal">

        <template v-slot:title>
            <div>{{ config.labels.addAProgram }}</div>
        </template>

        <template v-slot:content>
            <div class="vuw-modal-search grid-x"
                 :class="scrollableActive ? 'vuw-study-container-shadow' : ''">
                <SearchBarMolecule class="vuw-full-width"/>
            </div>
            <ScrollableModalContainer v-if="searchResults && searchResults.length"
                                      ref="scrollable"
                                      class="vuw-modal-content"
                                      v-on:scroll.native="handleScroll"
                                      :search-results="searchResults"/>
            <div v-else class="vuw-modal-content">
                <div class="vuw-relative grid-x vuw-study-container">
                    <HeadingCount :heading="config.labels.filteredNumberOfPrograms"
                                  :count-able="searchResults" />
                    <div class="grid-x vuw-full-width vuw-mv-1 vuw-pv-2">
                        <CardAtom card-class="vuw-align-center vuw-center vuw-border-1 vuw-border-support-7 vuw-text-seventh-7">
                            {{ config.labels.noResultsFound }}
                        </CardAtom>
                    </div>
                </div>
            </div>
        </template>
    </ModalComponent>
</template>
<script>
import {defineComponent, computed, ref} from "@vue/composition-api"
import {useActions, useGetters} from "vuex-composition-helpers"
import {searchFilter} from "@/apps/MyStudyChoiceFavoritesWidget/mixins/SearchMixin"
import ScrollableModalContainer from "../Modal/ScrollableModalContainer.vue"
import SearchBarMolecule from "@/shared/components/molecules/SearchBarMolecule.vue"
import ModalComponent from "../Modal/ModalComponent.vue"
import HeadingCount from "../Modal/HeadingCount.vue"
import CardAtom from "@/shared/components/atoms/card/CardAtom"

export default defineComponent({
    name: "StudySearch",
    components: {
        CardAtom,
        HeadingCount,
        ModalComponent,
        SearchBarMolecule,
        ScrollableModalContainer
    },
    setup: () => {
        const scrollable = ref(null)
        const scrollableActive = ref(false)
        const {setStudySearchModal} = useActions([
            'setStudySearchModal'
        ]);
        const {getStudySearchModal, getSearchQuery, getStudies, config} = useGetters([
            'getStudySearchModal',
            'getSearchQuery',
            'getStudies',
            'config'
        ]);

        const studySearchModal = computed({
            get() {
                return getStudySearchModal.value
            },
            set(studySearchModal) {
                setStudySearchModal(studySearchModal)
            }
        });

        const searchResults = computed(() => getStudies?.value?.filter(function (item) {
            return searchFilter(item, getSearchQuery.value)
        }))

        const handleScroll = function () {
            this.scrollableActive = scrollable.value.$el.scrollTop !== 0;
        }

        return {
            config,
            scrollable,
            handleScroll,
            searchResults,
            scrollableActive,
            studySearchModal
        }
    }
})
</script>